import { render, staticRenderFns } from "./organization-create.html?vue&type=template&id=21a4b8f9&scoped=true&external"
import script from "./organization-create.js?vue&type=script&lang=js&external"
export * from "./organization-create.js?vue&type=script&lang=js&external"
import style0 from "./organization-create.scss?vue&type=style&index=0&id=21a4b8f9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a4b8f9",
  null
  
)

export default component.exports